const isMobile = () => window.innerWidth <= 1160;
export const togglePackSummaryAccordion = (e, isBuildForMeFlow) => {
    e.preventDefault();

    let parentEl = $(e.currentTarget).closest('.edit-packsummary-container');
    let packSummaryContainer = parentEl.find('.pack-summary');
    let productTilesContainer = $('.product-tiles-wrapper');

    let isDropdownOpen = $(e.currentTarget).hasClass('open');
    let lastGroupSelected = $('.product-tiles-wrapper .product-tiles').last().data('completed');
    let packSummaryItemSelected = $('.pack-summary .pack-summary__item').last().attr('data-is-selected');
    if(isDropdownOpen) {
        $(e.currentTarget).removeClass('open');
        productTilesContainer.slideDown(500);
        packSummaryContainer.hide();
        if(isMobile() && lastGroupSelected) {
            $('.cart-add-btn').hide();
            $('.review-my-pack-btn').removeClass('d-none');
        }
        if(isMobile() && packSummaryItemSelected === 'true') {
            $('.cart-add-btn').hide();
            $('.review-my-pack-btn').removeClass('d-none');
        }
    } else {
        $(e.currentTarget).addClass('open');
        packSummaryContainer.slideDown(500);
        productTilesContainer.hide();
        if(isMobile() && lastGroupSelected) {
            $('.cart-add-btn').show();
            $('.review-my-pack-btn').addClass('d-none');
        }

        if(isMobile() && packSummaryItemSelected === 'true') {
            $('.cart-add-btn').show();
            $('.review-my-pack-btn').addClass('d-none');
        }
    }
};
